<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 活体 -->
		<div class="searchbox">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 20px;">
					<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.name"
						@keyup.enter.native="clickSearch" clearable size="small"></el-input>
					<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
				</div>
				<div style="margin-right: 20px;">
					<el-select v-model="params.shopId" placeholder="请选择" clearable @change="clickSearch" size="small" style="width: 120px;">
						<el-option v-for="item in this.$store.state.userInfo.shops" :key="item.shop_id"
							:label="item.shop_name" :value="item.shop_id">
						</el-option>
					</el-select>
				</div>
				<div style="margin-right: 20px;display: flex;align-items: center;">
					<div style="margin-right: 10px;">品级</div>
					<el-select style="width: 120px;" v-model="params.petGrade" placeholder="请选择" clearable
						@change="clickSearch" size="small">
						<el-option v-for="(item,index) in petType" :key='index' :label="item.name" :value="item._id">
						</el-option>

					</el-select>
				</div>
				<div style="margin-right: 20px;display: flex;align-items: center;">
					<div style="margin-right: 10px;">状态</div>
					<el-select style="width: 100px;" v-model="params.appShelves" placeholder="请选择" clearable
						@change="clickSearch" size="small">
						<el-option label="全部" :value="99">
						</el-option>
						<el-option label="未上架" :value="0">
						</el-option>
						<el-option label="上架" :value="1">
						</el-option>
						<el-option label="下架" :value="-1">
						</el-option>
					</el-select>
				</div>
				<div style="margin-right: 20px;display: flex;align-items: center;">
					<div style="margin-right: 10px;">性别</div>
					<el-select style="width: 100px;" clearable v-model="params.petSex" placeholder="请选择"
						@change="clickSearch" size="small">
						<el-option label="公" value="公">
						</el-option>
						<el-option label="母" value="母">
						</el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="con" :style="{height:fixedHeight-82+'px'}">
			<div class="left">
				<el-tree style="margin-top: 10px;" v-if="categoryData[0]" :data="categoryData[0].children"
					:highlight-current='isHighlight' node-key="id" default-expand-all :expand-on-click-node="false"
					@node-click='handleNodeClick'>
				</el-tree>
			</div>
			<div class="table">
				<el-table :data="petData" style="width: 100%;" size="small">
					<el-table-column label="分类" prop="breedInfo.name" width="160">
					</el-table-column>
					<el-table-column prop="petGrade" label="品级">
						<template slot-scope="scope">
							{{scope.row.petGrade == null?'--':scope.row.petGrade.name}}
						</template>
					</el-table-column>
					<el-table-column label="颜色" prop="petColor">
					</el-table-column>
					<el-table-column prop="petSex" label="性别" width="60">
					</el-table-column>
					<el-table-column prop="sale_price" label="门店销售价">
					</el-table-column>
					<el-table-column prop="onlineSalePrice" label="线上销售价">
					</el-table-column>
					<el-table-column label="特价宠物" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.isSpecialOffer==0">否</span>
							<span v-if="scope.row.isSpecialOffer==1">是</span>
						</template>
					</el-table-column>
					<el-table-column prop="epromNo" label="芯片编号" width="130">
					</el-table-column>
					<el-table-column prop="insideNo" label="脖圈编号" width="130">
					</el-table-column>
					<el-table-column label="状态" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.appShelves==0">未上架</span>
							<span v-if="scope.row.appShelves==1">上架</span>
							<span v-if="scope.row.appShelves==-1">下架</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px">
						<template slot-scope="scope">
							<el-button type="text" icon='el-icon-edit' size="small" @click='edit(scope.row._id)'>编辑
							</el-button>
							<el-button v-if="scope.row.appShelves == 0 || scope.row.appShelves == -1" type="text" size="small"
								@click='upOrDown(scope.row._id,1)'>上架</el-button>
							<el-button v-if="scope.row.appShelves==1" type="text" size="small"
								@click='upOrDown(scope.row._id,-1)'>下架</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :total="total" :page="params.pageIndex" :pageSize='params.pageSize' @change="changePage" style="padding: 10px 0;"></page>
			</div>
		</div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import {
		getPetList,
		getProductType,
		getPetType,
		isUpDown
	} from '../../../api/program.js'
	export default {
		components: {
			page
		},
		data() {
			return {
				params: {
					pageIndex: 1,
					pageSize: 12,
					name: '',
					shopid: '',
					minPrice: '',
					maxPrice: '',
					petGrade: '',
					petSex: '',
					appShelves: 99,
					breedid: '',
					petStatus: '1,3',
				},
				fixedHeight:'',
				total: 0,
				categoryData: [],
				isHighlight: true,
				petData: [],
				petType: [],
			}
		},
		methods: {
			getPetList() {
				getPetList(this.params).then(res => {
					if (res.code == 0) {
						console.log(res.data)
						this.petData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			getProductType() {
				getProductType({
					category: '活体'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data;
					}
				})
			},
			changePage(val) {
				this.params.pageIndex = val;
				this.getPetList();
			},
			clickSearch() {
				this.params.pageIndex = 1;
				this.getPetList();
			},
			handleNodeClick(data) {
				this.params.breedid = data.id;
				this.getPetList();
			},
			getPetType() {
				getPetType({
					type: '品级',
					class: '宠物',
				}).then(res => {
					if (res.code == 0) {
						this.petType = res.data.data;
					}
				})
			},
			edit(id) {
				this.$router.push({
					path: '/petshop/edit',
					query: {
						id
					}
				})
			},
			upOrDown(id, status) {
				isUpDown({
					petId: id,
					status: status
				}).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: status == 1 ? '上架成功' : '下架成功'
						});
						this.getPetList()
					}

				})
			}
		},
		created() {
			this.getPetList();
			this.getProductType();
			this.getPetType();
			this.fixedHeight = document.documentElement.clientHeight - 86;
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.searchbox {
		font-size: 14px;
		background: #fff;
		padding: 0 20px;
		height: 72px;
		display: flex;
		align-items: center;
	}

	.con {
		display: flex;
		margin-top: 10px;

		.left {
			width: 180px;
			background-color: #fff;
			margin-right: 20px;
			padding: 10px;
			overflow-y: scroll;
		}
		.table {
			flex: 1;
			background-color: #fff;
		}
	}
</style>
